import React from 'react';
import { Building2, Check } from 'lucide-react';
import { studioLabel } from './adminImportApi';

// The bar naming the studio everything is being imported into.
export function ImportTarget({ account, onChangeStudio, disabled = false }) {
  const studioName = studioLabel(account);
  return (
    <div className="pi-target">
      <Building2 size={18} aria-hidden="true" />
      <span className="pi-target-text">
        Importing into <strong>{studioName}</strong>
        {account.email && account.email !== studioName && (
          <span className="pi-muted"> · {account.email}</span>
        )}
      </span>
      <button
        type="button"
        className="pi-btn pi-btn--outline"
        onClick={onChangeStudio}
        disabled={disabled}
      >
        Change studio
      </button>
    </div>
  );
}

// Upload, map, review, import. `step` is 1-4; on 4 every step shows as done.
export function ImportStepper({ labels, step }) {
  return (
    <ol className="pi-stepper">
      {labels.map((label, index) => {
        const number = index + 1;
        const state =
          step === labels.length || number < step
            ? 'done'
            : number === step
              ? 'current'
              : 'upcoming';
        return (
          <li
            key={label}
            className={`pi-step is-${state}`}
            aria-current={state === 'current' ? 'step' : undefined}
          >
            <span className="pi-step-dot">
              {state === 'done' ? <Check size={16} strokeWidth={3} aria-hidden="true" /> : number}
            </span>
            <span className="pi-step-label">{label}</span>
          </li>
        );
      })}
    </ol>
  );
}

export function ImportHeader({ title, subtitle }) {
  return (
    <header className="pi-header">
      <h2>{title}</h2>
      <p>{subtitle}</p>
    </header>
  );
}
